// extracted by mini-css-extract-plugin
export var disabled = "styles-module--disabled--UgWi9";
export var link = "styles-module--link--WmTvD";